import React from 'react';
import PropTypes from 'prop-types';

import MojitoCore from 'mojito/core';

import {fetchInternalResource} from '#core/utils/utils.js';

import {Localization} from '#core/localization.js';

import {StaticPageView} from './static-page-view.jsx';

const UIPage = MojitoCore.Presentation.UIPage;
const staticPagesDownloadPath = '/static-pages/';

const staticPagePropTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

function initInstance(options) {
    this.state = {
        pageContent: '',
        headerKey: options.headerKey,
        hideGlobalLinks: options.hideGlobalLinks,
        downloadLink: options.downloadLink
            ? staticPagesDownloadPath + Localization.getCurrentLanguage() + '/' + options.downloadLink
            : undefined,
        dynamicBottomLink: options.dynamicBottomLink || null,
    };
    getStaticPage(options.filename)
        .then(html => this.setState({pageContent: html}))
        .catch(() => this.setState({pageContent: Localization.getTranslation('$STATIC_PAGE.NO_CONTENT')}));
}

export const staticHTMLPageFactory = options => {
    const buildClass = prototypeClass => {
        const clazz = class DynamicClass extends prototypeClass {
            constructor(reactComponent) {
                super(reactComponent);
                initInstance.call(this, options);
            }
        };
        return clazz;
    };

    return {
        buildPage: (toBeComponent = true) => {
            const Page = UIPage('StaticHtmlPage', buildClass(StaticPageView), staticPagePropTypes);
            return toBeComponent ? React.createElement(Page) : Page;
        },
        buildView: prototypeClass => {
            return buildClass(prototypeClass);
        },
    };
};

const log = MojitoCore.logger.get('StaticPageRetriever', {level: MojitoCore.logger.INFO});
const cache = Object.create(null);

function getStaticPage(filename) {
    return new Promise(function (success, fail) {
        const url = 'static-pages/' + Localization.getCurrentLanguageCode() + '/' + filename;

        if (cache[url] !== undefined) {
            return success(cache[url]);
        }

        fetchInternalResource(url)
            .then(response => {
                const contentType = response.headers.get('content-type');
                if (response.ok && contentType.includes('text/html')) {
                    return response.text();
                } else {
                    let message = `Server responds with ${response.status} and type '${contentType}'`;
                    return Promise.reject(`Cannot load page '${url}'.\n${message}`);
                }
            })
            .then(pageContent => {
                cache[url] = pageContent;
                success(pageContent);
            })
            .catch(err => {
                log.error(err);
                fail(err);
            });
    });
}
